import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#bausparvertrag

	{
		"angesparterBetrag": schemaBigDecimal,
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"sparbeitragMonatlich": schemaBigDecimal
	}

*/

export const schemaEuropaceBausparvertrag = z.object({
    angesparterBetrag: z.optional(schemaBigDecimal),
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    id: z.string().min(1),
    sparbeitragMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceBausparvertrag = z.infer<typeof schemaEuropaceBausparvertrag>;
